import { Box } from '@mui/system';
import { TextField } from '@mui/material';
import { WidgetOption } from './WidgetSelector';

type SemanticRanking = Models.SetsPlayground.KwdSetRanking;

interface Props {
    value: SemanticRanking;
    onChange: (next: SemanticRanking) => void;
}

const SemanticRankingWidgetComponent = ({ value, onChange }: Props): JSX.Element => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        onChange({ ...value, keywordSearchPhrase: e.target.value });
    };

    return (
        <Box display="grid" gap={2} gridTemplateColumns="1fr">
            <TextField
                fullWidth
                label="Keyword Search Phrase"
                placeholder="Birthday invitation"
                size="small"
                type="text"
                value={value.keywordSearchPhrase ?? ''}
                onChange={handleChange}
            />
        </Box>
    );
};

export const SemanticRankingWidget: WidgetOption<SemanticRanking> = {
    label: 'Semantic Ranking',
    value: 'semantic',
    helperText: 'Enter a keyword phrase for the semantic ranking (e.g., “Birthday invitation”).',
    component: SemanticRankingWidgetComponent,
    getDefaultValue: () => ({
        type: 'semantic',
        keywordSearchPhrase: '',
    }),
};
